import { render, staticRenderFns } from "./collaborators-select.vue?vue&type=template&id=08f285cb"
import script from "./collaborators-select.vue?vue&type=script&lang=js"
export * from "./collaborators-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports